import { axiosRIO } from '../axiosManager.js'

export default{
    getCharacter(name, realm = "malganis", region = "us") {
        return axiosRIO.get("characters/profile?region=" + region + "&realm=" + realm + "&name=" + name)
            .then(response => {
                console.log(response)
                return response.data
            })
    }
}